import { FC } from 'react'

export const formatAccountAbbreviation = (acc: string) => {
  if (!acc) return
  const splitString = acc?.split('')
  return `${splitString.splice(0, 4).join('')}...${splitString
    .splice(splitString.length - 4, splitString.length - 1)
    .join('')}`
}

const ConnectedWallet: FC = () => {
  return <></>
}

export default ConnectedWallet
